import React from "react"

import Container from "../../design-system/container"
import Header from "../../design-system/header"
import Modal from "../../design-system/modal"
import LegalDisbursementsForm from "./form"
import * as styles from "./index.module.scss"

interface Props {
  open: boolean
  onClose: () => void
}

const LegalDisbursementsModal = ({ open, onClose }: Props) => (
  <Modal
    open={open}
    onClose={() => onClose()}
    className={styles.modal}
    data-testid="legal-disbursements-modal"
  >
    <Container className={styles.container}>
      <Header as="h4" variant="4">
        Schedule a short call to see how Tremendous can save you time, money,
        and hassle.
      </Header>
      <LegalDisbursementsForm />
    </Container>
  </Modal>
)

export default LegalDisbursementsModal
